module.exports = __webpack_public_path__ + "img/Sinovation.9d6e953a.jpg";